import { createRef, Component } from 'react';
import TextField from '@material-ui/core/TextField';
import { useLocation } from 'react-router-dom';

import Button from '../components/Button';
import {
  Centered,
  Inset,
  Page,
  Loading,
} from '../components/Styles';
import logotype from './img/market_2day_logotype.svg';

import Vault from '../helpers/Vault';

import build from '../build';

class SignIn extends Component {
  constructor(props) {
    super(props);
    this.passwordInput = createRef();
    this.setPasswordInputRef = (element) => {
      this.passwordInput = element;
    };

    this.focusPasswordInput = () => {
      // Focus the text input using the raw DOM API
      if (this.passwordInput) this.passwordInput.focus();
    };

    // Reach out to see if customer id is stored
    Vault.get(Vault.keys.USER_ID)
      .then((email) => {
        this.setState({ email });
      })
      .catch((err) => Console.log(`${err}, which is ok`));
  }

  state = {
    email: '',
    password: '',
    loggingIn: false,
  };

  componentDidMount = () => {
    if (this.props.auth) {
      this.props.history.push('/');
    }
  }

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value });
  };

  handleForgot = () => {
    this.props.forgot(this.state.email);
  };

  handleLogin = () => {
    this.state.loggingIn = true;
    const { email } = this.state;
    const { resume } = this.props;
    this.props.login(email, this.state.password, () => {
      this.props.history.push(resume || '/');
    }).then(() => {
      this.state.loggingIn = false;
    }).catch((e) => {
      console.log(Error(e));
    });
  };

  // These a11y warns apply to an easter egg / backdoor
  /* eslint-disable jsx-a11y/click-events-have-key-events */
  /* eslint-disable jsx-a11y/no-static-element-interactions */
  render() {
    const { resume } = this.props;
    return (
      <Page>
        <Centered>
          <img
            alt="Market 2day"
            src={logotype}
            css={{ marginTop: '2rem' }}
          />
        </Centered>
        <Inset css={{ marginTop: '2rem' }}>
          <TextField
            id="email"
            InputProps={{ type: 'email' }}
            label="E-mail"
            defaultValue={this.state.email}
            onChange={this.handleChange('email')}
            margin="normal"
            css={{ marginTop: '20px' }}
            error={this.props.errors && this.props.errors.email}
            helperText={this.props.errors && this.props.errors.email}
            value={this.state.email}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                this.focusPasswordInput();
              }
            }}
          />
          <TextField
            id="password"
            label="Password"
            type="password"
            defaultValue={this.state.password}
            onChange={this.handleChange('password')}
            autoComplete="current-password"
            margin="normal"
            error={this.props.errors && this.props.errors.password}
            helperText={this.props.errors && this.props.errors.password}
            inputRef={this.setPasswordInputRef}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                this.handleLogin();
              }
            }}
          />
          <Centered css={{ marginTop: '2rem' }}>
            { this.state.loggingIn
              ? (
                <div className="py-2">
                  <Loading>
                    Logging in
                  </Loading>
                </div>
              )
              : (
                <Button
                  onClick={this.handleLogin}
                >
                  Log In
                </Button>
              )}
            { (this.props.errors && this.props.errors.password)
              ? (
                <Button variant="secondary" css={{ marginTop: '1rem' }} onClick={this.handleForgot}>
                  Forgot Password
                </Button>
              ) : null }
            <h3 css={{ marginTop: '2rem' }}>New to Market 2day?</h3>
            <Button
              variant="secondary"
              css={{ marginTop: '1rem' }}
              to={resume ? `/signup?resume=${resume}` : '/signup'}
            >
              Sign Up Now!
            </Button>
            <div css={{ marginTop: '5rem', fontSize: 'x-small', color: '#aaa' }} onClick={() => { window.location.reload(); }}>Version { build } © 2022 Market 2day</div>
          </Centered>
        </Inset>
      </Page>
    );
  }
}

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

// FIXME this wrapper can go away if we refactor this
// to be a functional component
const SignInWrapper = (props) => {
  const query = useQuery();
  return (
    <SignIn resume={query.get('resume')} {...props} />
  );
};

export default SignInWrapper;
